import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const mobileBreakpoint = 1500

export default new Vuex.Store({
  state: {
    content: {},
    mobile: window.innerWidth <= mobileBreakpoint,
    navigation: {
      open: false,
    },
    slideshow: {
      title: false,
      year: false,
      category: false,
      paw: false,
      index: 0,
    },
    showChannels: false,
    cartData: null,
  },
  mutations: {
    setData(state, { key, data }) {
      Vue.set(state.content, key, data)
    },
    updateMobile(state) {
      let updated = window.innerWidth <= mobileBreakpoint
      if (state.mobile !== updated) {
        state.mobile = updated
      }
    },
    updateNavigationMeta(state, data) {
      Object.keys(data).forEach((key) => {
        state.navigation[key] = data[key]
      })
    },
    updateSlideshowMeta(state, data) {
      Object.keys(data).forEach((key) => {
        state.slideshow[key] = data[key]
      })
    },
    setShowChannels(state, bool) {
      state.showChannels = bool
    },
    setCartData(state, data) {
      state.cartData = data
    },
  },
  actions: {
    fetchData({ commit }, path) {
      const api = process.env.VUE_APP_API_URL

      if (api) {
        fetch(api + path)
          .then(function(response) {
            return response.json()
          })
          .then(function(json) {
            commit('setData', {
              key: path,
              data: json,
            })
          })
          .catch(function() {})
      }
    },
    setShowChannels({ commit }, bool) {
      commit('setShowChannels', bool)
    },
    setCartData({ commit }, data) {
      commit('setCartData', data)
    },
  },
})
